import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2WrittenAssignmentIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 41.505 35.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 35.5),
    children: /*#__PURE__*/jsx("path", {
      d: "M39.008 17.49l-15.25 15.26-7.5 1.5 1.5-7.5L33.02 11.49a4.226 4.226 0 015.982 0l.018.016a4.232 4.232 0 01-.012 5.984zM1.75 1.25h24M1.25 10.25h24.5M1.25 19.25h15"
    })
  });
};

export { PM2WrittenAssignmentIcon };
//# sourceMappingURL=written-assignment.js.map
